module.exports = __webpack_public_path__ + "static/img/19034103295190235.23c0ed52.jpg";